$(document).ready(function () {
  var forLoop = $(".nutritalk-inner--div .nutritalk-image--with--text--div").attr("forloop");
  if (forLoop <= 2) {
    $(".nutritalk-inner--div").addClass("nutritalk-inner--div-display"); 
  }
  if (forLoop > 2) {
    $(".nutritalk-inner--div").slick({
      slidesToScroll: 1,
      slidesToShow: 2,
      dots: true,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:
        '<button type="button" class="slick-next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="white" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      responsive: [
        {
          breakpoint: 749,
          settings: { centerPadding: "80px", slidesToShow: 1, arrows: false },
        },
      ],
    });
  }
});
